import { Button } from '@mui/material';
import React from 'react';

// eslint-disable-next-line react/prop-types
const FlatButton = ({ label, primary, ...props }) => (
  <Button variant="text" color={primary ? 'primary' : 'default'} {...props}>{label}</Button>
);

export default FlatButton;
